import { render } from "./XIconSolidSmile.vue?vue&type=template&id=63d8b095"
import script from "./XIconSolidSmile.vue?vue&type=script&lang=js"
export * from "./XIconSolidSmile.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidSmile.vue"]])

export default __exports__